import { createRootRoute, Outlet } from "@tanstack/react-router";
import * as Sentry from "@sentry/react";

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <Outlet />
    </Sentry.ErrorBoundary>
  );
}
